// extracted by mini-css-extract-plugin
export var container = "_eb-0";
export var content = "_eb-3";
export var customerTitle = "_eb-4";
export var empty = "_eb-5";
export var gray = "_eb-6";
export var header = "_eb-7";
export var info = "_eb-8";
export var loading = "_eb-2";
export var loadingCard = "_eb-9";
export var oneLine = "_eb-a";
export var personName = "_eb-e";
export var pillContainer = "_eb-b";
export var selected = "_eb-1";
export var text = "_eb-c";
export var twoLines = "_eb-d";
export var unread = "_eb-f";
export var unreadIndicator = "_eb-g";